<template>
    <v-card
        class="d-block d-md-flex mr-6 mb-6">
        <figure
            v-if="element.image"
            class="pa-3 d-flex align-center justify-center">
            <v-img
                :src="element.image.url"
                :width="element.image.width"
                :height="element.image.height"
                contain/>
        </figure>
        <div class="d-flex flex-column">
            <v-card-title>
                <span
                    class="company mr-4"
                    v-text="element.name"/>
                <span
                    v-if="!element.to"
                    v-html="'Depuis&nbsp;'"/>
                <span v-text="element.from"/>
                <span
                    v-if="element.to && element.to !== element.from"
                    v-html="'&nbsp;-&nbsp;' + element.to"/>
            </v-card-title>

            <v-card-subtitle
                v-if="element.description"
                v-text="element.description"
                class="pb-0"/>

            <v-card-title
                v-text="element.position"
                class="pt-0"/>

            <v-card-text class="missions flex-grow-1">
                <div
                    v-for="(mission, index) in element.missions"
                    :key="`${element.name}-mission-${index}`">
                    <v-icon size="25">
                        mdi-menu-right
                    </v-icon>
                    <span v-text="mission"/>
                </div>
            </v-card-text>

            <v-card-actions
                v-if="element.environment"
                class="env d-inline-block px-4 pb-4 font-italic">
                        <span
                            class="text-decoration-underline mr-1"
                            v-text="'Environnement technique:'"/>

                {{ element.environment.join(', ') }}
            </v-card-actions>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'experiencesElement',
    props: {
        element: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped lang="scss">
.v-card {
    width: 600px !important;
    min-width: 600px !important;
}

.v-card__title > span:not(.company) {
    font-size: 14px !important;
    color: #aaa !important;
    margin-bottom: -5px !important;
    font-weight: 300 !important;
}

.v-card__actions {
    color: #aaa !important;
    font-size: 13px !important;
}

.v-icon.mdi-menu-right {
    height: 22px !important;
    width: 8px !important;
}

@media (max-width: 600px) {
    .v-card {
        width: 100% !important;
        min-width: 100% !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/experiences/experiencesElement.vue